import { useQuery } from "@tanstack/react-query";

// Master switch for the consultation experience: live | coming_soon | hidden (super admin controlled).
export const useConsultEnabled = () => {
    const { data, isLoading } = useQuery({
        queryKey: ["consult-status"],
        queryFn: async () => (await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/consult/status`)).json(),
        staleTime: 60000,
    });
    const mode = data?.mode || (data?.enabled ? "live" : undefined);
    return {
        mode,
        enabled: mode === "live",
        showLink: mode === "live" || mode === "coming_soon",
        comingSoon: data?.coming_soon || {},
        loading: isLoading || data === undefined,
    };
};
